import { BsArrowUpCircleFill } from 'react-icons/bs';

export default function ChatInput({ message, setMessage, handleSend }) {
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <div
      className="sticky bottom-0 p-4 bg-white border border-[#F0F0F0] rounded-2xl h-24 min-h-24"
      style={{
        boxShadow: `0px 6px 12px 0px #BABABA14,0px 23px 23px 0px #BABABA12,0px 51px 31px 0px #BABABA0A,0px 90px 36px 0px #BABABA03,0px 141px 40px 0px #BABABA00`,
      }}
    >
      <div className="relative flex items-center justify-between h-full gap-1">
        <textarea
          rows={1}
          className="flex-1 w-full h-full text-[#7B7B7B] resize-none text-md ring-0 focus:outline-none leading-tight"
          placeholder="Ask anything"
          value={message}
          autoFocus
          onChange={(e) => setMessage(e.target.value)}
          onKeyDown={handleKeyDown}
        />
        <BsArrowUpCircleFill
          className={`size-7 ${
            !message
              ? 'text-[#DCDCDC] pointer-events-none'
              : 'text-[#0096ae] pointer-events-auto'
          } cursor-pointer self-end`}
          onClick={handleSend}
        />
      </div>
    </div>
  );
}
